// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2LKrA","productName":"Table_productName__jhKbw"};